export const setProfileImageSrc = (src) => ({
  type: 'SET_PROFILE_IMAGE_SRC',
  src: src,
});
